module.exports = __webpack_public_path__ + "static/media/centri_znanja_logo.17055dee.png";